import type { PropsWithChildren } from 'react'
import { isPrivateVersion } from '@/constants/common.ts'

export function PrivateDeployGuard(props: PropsWithChildren) {
  return isPrivateVersion ? null : props.children
}
